import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdminService } from 'src/app/core';
import { DeliveryMethodDto } from 'src/app/shared';
import { cities } from 'src/app/core/json/cities';

@Component({
  selector: 'app-add-delivery-method',
  templateUrl: './add-delivery-method.component.html',
})
export class AddDeliveryMethodComponent {
  public isEditMode: boolean = false;
  deliveryMethod: DeliveryMethodDto;
  public form: FormGroup;
  cityList = cities;

  constructor(
    @Inject(MAT_DIALOG_DATA) dialogData: any,
    private fb: FormBuilder,
    private adminService: AdminService
  ) {
    this.form = fb.group({
      name: [null, Validators.required],
      icon: ['archive', Validators.required],
      valueAdded: ['0'],
      desc: [null],
      minPurchaseForFreeShipping: [null],
      cities: [null],
    });
    if (dialogData.editMode) this.isEditMode = dialogData.editMode;
    if (dialogData.deliveryMethod) {
      this.deliveryMethod = dialogData.deliveryMethod;
      console.log(this.deliveryMethod);
      this.fillForm();
    }
  }

  fillForm() {
    this.form.controls['name'].setValue(this.deliveryMethod.name);
    this.form.controls['icon'].setValue(this.deliveryMethod.icon);
    this.form.controls['valueAdded'].setValue(this.deliveryMethod.valueAdded);
    this.form.controls['desc'].setValue(this.deliveryMethod.desc);
    this.form.controls['minPurchaseForFreeShipping'].setValue(
      this.deliveryMethod.minPurchaseForFreeShipping
    );
    this.form.controls['cities'].setValue(this.deliveryMethod.cities?.map(city => city.id));
  }

  updateMethod() {
    const request = this.form.value;
    if (!request.minPurchaseForFreeShipping || request.valueAdded == 0) {
      delete request.minPurchaseForFreeShipping;
    }
    if (request.valueAdded) request.valueAdded = Number(request.valueAdded);
    if (request.minPurchaseForFreeShipping) request.minPurchaseForFreeShipping = Number(request.minPurchaseForFreeShipping);
    this.adminService
    .updateDeliveryMethod(this.form.value, String(this.deliveryMethod.id))
    .subscribe((res: any) => console.log(res));
  }
  addMethod() {
    const request = this.form.value;
    if (!request.minPurchaseForFreeShipping || request.valueAdded == 0) {
      delete request.minPurchaseForFreeShipping;
    }
    if (request.valueAdded) request.valueAdded = Number(request.valueAdded);
    if (request.minPurchaseForFreeShipping) request.minPurchaseForFreeShipping = Number(request.minPurchaseForFreeShipping);
    this.adminService
      .addDeliveryMethod(this.form.value)
      .subscribe((res:any) => console.log(res));
  }
}
